/**
 * Bộ lọc theo tháng của Bảng kê công nợ (Roary 04/11/2026, mục 10): chọn một tháng của năm nay hoặc năm trước thay vì tự gõ hai ngày.
 * Tháng = "Đầu kỳ" ngày 1 + "Công nợ đến hết ngày" cuối tháng (tháng đang chạy thì tới hôm nay) — chính hai ô màn hình đã có, nên số dư
 * đầu kỳ, chứng từ trong tháng và số dư cuối tháng tính đúng như khi gõ tay. Ngày theo dạng YYYY-MM-DD như các ô ngày của màn.
 */
export interface StatementMonth {
  /** `YYYY-MM` */
  value: string;
  year: number;
  month: number;
}

const pad = (n: number) => String(n).padStart(2, "0");
const lastDay = (year: number, month: number) => new Date(year, month, 0).getDate();

/** Các tháng chọn được: từ tháng hiện tại lùi về tháng 1 của năm trước (mới nhất trước). `today` dạng YYYY-MM-DD. */
export function statementMonthOptions(today: string): StatementMonth[] {
  const [y, m] = today.split("-").map(Number) as [number, number];
  const out: StatementMonth[] = [];
  for (let year = y, month = m; year > y - 2; month--) {
    if (month === 0) {
      year--;
      month = 12;
      if (year <= y - 2) break;
    }
    out.push({ value: `${year}-${pad(month)}`, year, month });
  }
  return out;
}

/** Khoảng ngày của một tháng `YYYY-MM`: từ ngày 1 tới cuối tháng, hoặc tới `today` nếu là tháng đang chạy. */
export function statementMonthRange(value: string, today: string): { from: string; asOf: string } | null {
  const match = /^(\d{4})-(\d{2})$/.exec(value);
  if (!match) return null;
  const year = Number(match[1]), month = Number(match[2]);
  if (month < 1 || month > 12) return null;
  const from = `${year}-${pad(month)}-01`;
  if (from > today) return null;
  const end = `${year}-${pad(month)}-${pad(lastDay(year, month))}`;
  return { from, asOf: end < today ? end : today };
}

/** Tháng đang được chọn, nếu hai ô ngày đúng là trọn một tháng (theo `statementMonthRange`); không thì chuỗi rỗng. */
export function statementMonthOf(from: string, asOf: string, today: string): string {
  const value = from.slice(0, 7);
  const range = statementMonthRange(value, today);
  return range && range.from === from && range.asOf === asOf ? value : "";
}
